import SelectorEngine from '../../utils/dom/selector-engine';
import FormComponent from '../FormComponent';
import InputField from '../InputField';
import _ from "lodash";

class ParkAddressSearch extends FormComponent {
	constructor(element, config) {
		super(element, config);
	}
	markup(value, rowData, titleMarkup) {
        return `
            <div class="lta-park-address-search">
                <div class="u-mb-4">
                    ${this.renderInstructionLabel(rowData?.instructionText)}
                </div>
				<div class="lta-park-address-search-title u-hidden">${titleMarkup}</div>
                <div class="lta-park-address-search--address-form u-mb-2">
                    <div class="lta-park-address-search--park-name u-mb-3"></div>
                    <div class="lta-park-address-search--address-line1 u-mb-3"></div>
                    <div class="lta-park-address-search--address-line2 u-mb-3"></div>
                    <div class="lta-park-address-search--town u-mb-3"></div>
                    <div class="lta-park-address-search--postcode u-mb-3"></div>
                </div>
            </div>`;
	}
    renderInstructionLabel(instructionLabel) {
		return instructionLabel ? `<span class="lta-text-input__label-instruction">${instructionLabel}</span>` : '';
	}
	afterRender() { 
		this.parkAddressSearchElement = SelectorEngine.findOne('.lta-park-address-search', this.containerEl);
        this.parkAddressSearchForm = SelectorEngine.findOne('.lta-park-address-search--address-form', this.parkAddressSearchElement);
        this.parkAddressParkName = SelectorEngine.findOne('.lta-park-address-search--park-name', this.parkAddressSearchForm);
        this.parkAddressAddressLine1 = SelectorEngine.findOne('.lta-park-address-search--address-line1', this.parkAddressSearchForm);
        this.parkAddressAddressLine2 = SelectorEngine.findOne('.lta-park-address-search--address-line2', this.parkAddressSearchForm);
        this.parkAddressTown = SelectorEngine.findOne('.lta-park-address-search--town', this.parkAddressSearchForm);
        this.parkAddressPostcode = SelectorEngine.findOne('.lta-park-address-search--postcode', this.parkAddressSearchForm);
        this.addressObjects = [];
        this.addressObjects = [
            {
                inputElementData: this.parkAddressParkName,
                elementDataKey: 'venueName'
            },
            {
                inputElementData: this.parkAddressAddressLine1,
                elementDataKey: 'addressLine1'
            },
            {
                inputElementData: this.parkAddressAddressLine2,
                elementDataKey: 'addressLine2'
            },
            {
                inputElementData: this.parkAddressTown,
                elementDataKey: 'county'
            },
            {
                inputElementData: this.parkAddressPostcode,
                elementDataKey: 'postcode'
            },
        ];
        this.initInputObject();
	}
    initInputObject() {
        let parkSearchAddressObject = {};
        for (const addressObject of  this.addressObjects) {
            const inputFieldObject = new InputField(addressObject.inputElementData, {
                data: this.data[addressObject.elementDataKey]
            });
            addressObject.inputElement = inputFieldObject;
            inputFieldObject.onChange((dataObject) => {
                addressObject.value = dataObject.value;
                if(addressObject?.value?.length > 2 ) {
                    const valueObject = {
                        address: {
                            street: null,
                            city: null,
                            state: null
                        }
                    };
                    valueObject[addressObject.elementDataKey] = addressObject?.value;
                    parkSearchAddressObject = {
                        ...parkSearchAddressObject,
                        ...valueObject
                    }
                }

                if(_.size(parkSearchAddressObject) === (this.addressObjects?.length + 1)) {
                    const finalObject = this.prepareAddressObject(parkSearchAddressObject);
                    this.value = {
                        ...this.value,
                        ...finalObject
                    };
                }
            });
        }
    }
    prepareAddressObject(parkObject) {
        const modifyObject = {
            "id": '',
            "venueName": parkObject.venueName,
            "county": '',
            "postcode": parkObject.postcode,
            "address": {
               "street": parkObject.addressLine1,
               "city":parkObject.addressLine2,
               "state":parkObject.county
            }
         };
         return modifyObject;
    }
	validate() {
        for (const inputElementObject of this.addressObjects) {
            inputElementObject.inputElement.validate();
        }
	}
}
export default ParkAddressSearch;
